import React from 'react';
import ReactECharts from 'echarts-for-react';

const AdminAnalytics = ({ entries }) => {
  const scratchCount = entries.filter(e => e.gameType === 'Scratch Card').length;
  const spinCount = entries.filter(e => e.gameType === 'Spin Wheel').length;

  // Calculate Reward Distribution
  const rewardCounts = {};
  entries.forEach(e => {
    rewardCounts[e.reward] = (rewardCounts[e.reward] || 0) + 1;
  });
  const rewardData = Object.keys(rewardCounts).map(key => ({
    name: key,
    value: rewardCounts[key]
  })).sort((a, b) => b.value - a.value);

  const campaignOption = {
    tooltip: { trigger: 'item' },
    legend: { top: 'bottom', textStyle: { color: '#94a3b8' } },
    series: [
      {
        name: 'Participants',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: { borderRadius: 10, borderColor: '#1e293b', borderWidth: 2 },
        label: { show: false, position: 'center' },
        emphasis: { label: { show: true, fontSize: 18, fontWeight: 'bold', color: '#fff' } },
        labelLine: { show: false },
        data: [
          { value: scratchCount, name: 'Scratch Card', itemStyle: { color: '#f97316' } },
          { value: spinCount, name: 'Spin Wheel', itemStyle: { color: '#3b82f6' } }
        ]
      }
    ]
  };

  const rewardOption = {
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'value', splitLine: { lineStyle: { color: '#334155' } }, axisLabel: { color: '#94a3b8' } },
    yAxis: { type: 'category', data: rewardData.map(d => d.name), axisLabel: { color: '#94a3b8', width: 120, overflow: 'truncate' } },
    series: [
      {
        name: 'Wins',
        type: 'bar',
        data: rewardData.map(d => d.value),
        itemStyle: {
          color: '#10b981',
          borderRadius: [0, 4, 4, 0]
        }
      }
    ]
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="glass-panel p-6 rounded-2xl bg-slate-800/50 border-slate-700">
        <h3 className="text-lg font-bold text-white mb-4">Campaign Popularity</h3>
        {entries.length === 0 ? (
          <div className="h-[300px] flex items-center justify-center text-slate-500">No data available</div>
        ) : (
          <ReactECharts option={campaignOption} style={{ height: '300px' }} theme="dark" opts={{ renderer: 'svg' }} />
        )}
      </div>

      <div className="glass-panel p-6 rounded-2xl bg-slate-800/50 border-slate-700">
        <h3 className="text-lg font-bold text-white mb-4">Reward Distribution</h3>
        {entries.length === 0 ? (
          <div className="h-[300px] flex items-center justify-center text-slate-500">No data available</div>
        ) : (
          <ReactECharts option={rewardOption} style={{ height: '300px' }} theme="dark" opts={{ renderer: 'svg' }} />
        )}
      </div>
    </div>
  );
};

export default AdminAnalytics;